import { getMyCommentList } from '@/api/forum';

const PAGE_SIZE = 20;

export const createForumMyCommentList = () => ({
  list: [],
  loading: false,
  fetching: false,
  finished: false,
  page: 1,
  async load(reset = false) {
    if (this.fetching) return;
    if (reset) {
      this.list = [];
      this.page = 1;
      this.finished = false;
    }
    if (this.finished) {
      this.loading = false;
      return;
    }

    this.fetching = true;
    this.loading = true;
    try {
      const res = await getMyCommentList({ page: this.page, size: PAGE_SIZE });
      const records = res.data.list;
      this.list.push(...records);
      if (records.length < PAGE_SIZE) this.finished = true;
      else this.page += 1;
    } catch (error) {
      this.finished = true;
    } finally {
      this.fetching = false;
      this.loading = false;
    }
  },
});
